import { getEnvFromOrigin } from '../contexts/AppContext';

export const redirectToAuth0 = () => {
  window.location.href = getAuth0CallbackUriV2({});
};

type Auth0CallbackOptions = {
  connection?: string;
  signup?: boolean;
};

export const getAuth0CallbackUriV2 = (options: Auth0CallbackOptions): string => {
  const env = getEnvFromOrigin();
  const params = new URLSearchParams();

  if (typeof options.connection === 'string') {
    params.set('connection', options.connection);
  }

  if (options.signup === true) {
    params.set(`screen`, `signup`);
  }

  return `https://developer.${env}.finverse.net/auth/login_v2?${params.toString()}`;
};
